import { Box, Tooltip, Typography } from '@mui/material';

type Props = {
  records: string[];
};

export default function AssociatedRecords({ records }: Props) {
  const primary = records[0] ?? 'Unknown Caller';
  const extraCount = Math.max(records.length - 1, 0);

  return (
    <Box display='flex' alignItems='center' gap={0.5}>
      <Typography variant='body2'>{primary}</Typography>
      {extraCount > 0 && (
        <Tooltip title={records.join(', ')} arrow placement='top'>
          <Typography variant='body2' color='primary' sx={{ cursor: 'pointer', fontWeight: 500, whiteSpace: 'nowrap' }}>
            +{extraCount}
          </Typography>
        </Tooltip>
      )}
    </Box>
  );
}
